// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import axios from "axios";
import Vue from "vue";

import App from "./App";
import router from "./router/index";
import { store } from "./store/store";
// import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import GoTop from "@inotom/vue-go-top";
import VueLazyload from "vue-lazyload";
import carousel from "vue-owl-carousel";
import "vue-select/dist/vue-select.css";
import VueSimpleAlert from "vue-simple-alert";
import VueSocialSharing from "vue-social-sharing";
import VueTypedJs from "vue-typed-js";
// import VCalendar from 'v-calendar';
import Vuelidate from "vuelidate";
// import Vuelidate from "vuelidate/src";
import VueMeta from "vue-meta";

import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

import {
  ButtonPlugin,
  CalendarPlugin,
  CardPlugin,
  CollapsePlugin,
  FormDatepickerPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormPlugin,
  LayoutPlugin,
  TooltipPlugin
} from "bootstrap-vue";

import LazyTube from "vue-lazytube";
Vue.use(LazyTube);
Vue.use(VuePlyr, {
  plyr: {}
});
Vue.use(CollapsePlugin);
Vue.use(TooltipPlugin);
Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(CalendarPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(FormGroupPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormPlugin);

Vue.config.productionTip = false;
Vue.use(VueTypedJs);
Vue.use(VueLazyload);
Vue.use(VueSocialSharing);
Vue.use(VueSimpleAlert);
Vue.use(Vuelidate);
Vue.use(VueMeta);

const prod = process.env.NODE_ENV === "production";
const shouldSW = "serviceWorker" in navigator && prod;
if (shouldSW) {
  navigator.serviceWorker.register("/service-worker.js").then(() => {
    console.log("Service Worker Registered!");
  });
}

Vue.use(GoTop);
// Vue.component('v-select', vSelect)
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

import "./assets/css/custom.css";
import "./assets/css/fonts/icomoon/style.css";
import "./assets/css/main.css";

router.beforeResolve((to, from, next) => {
  if (
    store.state.favourite.some(item => {
      return item.name === to.name;
    }) == false
  ) {
    if (store.state.favourite.length == 5) {
      store.state.favourite.splice(0, 1);
    }
    store.state.favourite.push({
      name: to.name,
      title: to.meta.title,
      description: to.meta.description
    });
  }
  next();
});

router.afterEach((to, from) => {});

axios.defaults.headers.common = { Accept: "application/json" };
// axios.defaults.baseURL = 'http://172.16.10.107:8000/api/v1/';
axios.defaults.baseURL = "https://web.idlc.com/api/v1/";
// axios.defaults.baseURL = "https://idlc-fl.singularitybd.net/api/v1/";

new Vue({
  router,

  store,
  render: h => h(App)
}).$mount("#app");
Vue.component("carousel", carousel);



// WEBPACK FOOTER //
// ./src/main.js